import { fetchJSON, POST, GET } from 'utils/http';
import {
  SAVE_COACH_PROFILE,
  GET_COACH_PROFILE,
  ADD_POSTING,
  GET_ALL_POSTINGS,
  GET_POSTING_BY_ID,
  UPDATE_POSTING,
  DELETE_POSTING,
  VALIDATE_COACH_FROM_DATABASE,
}
    from 'constants/urls';

export function saveCoach(data) {
  return fetchJSON(SAVE_COACH_PROFILE, POST, {}, data, {});
}

export function getCoach(id) {
  return fetchJSON(GET_COACH_PROFILE + id, GET, {}, {}, {});
}

export function storePosting(data) {
  return fetchJSON(ADD_POSTING, POST, {}, data, {});
}

export function getAllPostingsById(id) {
  return fetchJSON(GET_ALL_POSTINGS + id, GET, {}, {}, {});
}

export function editPosting(id) {
  return fetchJSON(GET_POSTING_BY_ID + id, GET, {}, {}, {});
}

export function updatePosting(payload) {
  return fetchJSON(UPDATE_POSTING, POST, {}, payload, {});
}

export function deletePostingById(id) {
  return fetchJSON(DELETE_POSTING + id, GET, {}, {}, {});
}

export function validataCoachFromDatabase(data) {
  return fetchJSON(VALIDATE_COACH_FROM_DATABASE, POST, {}, data, {});
}



// WEBPACK FOOTER //
// ./src/common/services/coachProfile.service/coachProfile.service.js